import React from 'react';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';
import HoverTooltip from '../interface/hoverTooltip';

const TextBox = React.forwardRef((props, ref) => {
  const {
    className,
    styleType,
    type,
    id,
    value,
    onChange,
    autoComplete,
    maxlength,
    labelLocale,
    onKeyEnter,
    onKeyEsc,
    disabled,
    dataType,
    showClearTextButton,
    toolTipContent,
  } = props;
  
  const handleOnChange = (event) => {
      if(dataType && (dataType.toUpperCase() in Constants.selectKeys.metric.dataType)) {
        var changedValue = event.currentTarget.value.trim();        
        let oldPosition = event.currentTarget.selectionStart;
        let hasMinus = false;
        switch (dataType) {
          case Constants.selectKeys.metric.dataType.NUMBER:            
            if(changedValue.length>0 && changedValue[0]=="-") {
              changedValue = changedValue.replace("-", "");
              hasMinus = true;
            }
            if(isNaN(changedValue)) {
              event.currentTarget.value = value ? value : "";
              event.currentTarget.selectionStart = oldPosition-1;
              event.currentTarget.selectionEnd = oldPosition-1;
            } else if (changedValue.length>0 || hasMinus) {
              changedValue = hasMinus ? "-" + changedValue : changedValue;
              event.currentTarget.value = changedValue;
            } else {
              event.currentTarget.value = "";
            }
            break;
          case Constants.selectKeys.metric.dataType.PERCENTAGE:
            if(changedValue.length>0 && changedValue[0]=="-") {
              changedValue = changedValue.replace("-", "");
              hasMinus = true;
            }
            if(changedValue.length>0 && changedValue[changedValue.length-1]=="%") {
              changedValue = changedValue.replace("%", "").trim();
            }
            if(isNaN(changedValue)) {
              event.currentTarget.value = value ? value : "";
              event.currentTarget.selectionStart = oldPosition-1;
              event.currentTarget.selectionEnd = oldPosition-1;
            } else if (changedValue.length>0 || hasMinus) {
              changedValue = hasMinus ? "-" + changedValue : changedValue;
              let valueBeforeMask = event.currentTarget.value;
              event.currentTarget.value = changedValue + "%";
              if(changedValue.length == 1) {                
                event.currentTarget.selectionStart = 1;
                event.currentTarget.selectionEnd = 1;
              } else if (valueBeforeMask.indexOf("%") == -1) {
                event.currentTarget.selectionStart = event.currentTarget.value.length-1;
                event.currentTarget.selectionEnd = event.currentTarget.value.length-1;
              }
            } else {
              event.currentTarget.value = "";
            }
            break;
          case Constants.selectKeys.metric.dataType.BOOLEAN:
            if(isNaN(changedValue) || 
              (!isNaN(changedValue) && changedValue!=1 && changedValue!=0) || 
              changedValue.length>1) {
              event.currentTarget.value = value ? value : "";
              event.currentTarget.selectionStart = oldPosition-1;
              event.currentTarget.selectionEnd = oldPosition-1;
            } else if (changedValue.length>0) {
              event.currentTarget.value = changedValue;
            } else {
              event.currentTarget.value = "";
            }
            break;
          case Constants.selectKeys.metric.dataType.DATE:
            changedValue = changedValue.replace(/\//g, "");
            changedValue = changedValue.replace(/\s/g, "");
            if(isNaN(changedValue) || 
              changedValue.indexOf(".")>-1 ||
              changedValue.length>8) {
              event.currentTarget.value = value ? value : "";
            }
            else {
              var mask = "__/__/____";
              var result = [];
              var replacedIndex = 0;
              for(var i=0; i<mask.length; i++) {
                if(mask[i]=="_" && replacedIndex<changedValue.length) {
                  result[i] = changedValue[replacedIndex];
                  replacedIndex++;
                }
                else if(replacedIndex<changedValue.length) {
                  result[i] = mask[i]
                }
              }
              event.currentTarget.value = result.join('');
            }            
            break;
          case Constants.selectKeys.metric.dataType.DATETIME:
            changedValue = changedValue.replace(/\//g, "");
            changedValue = changedValue.replace(/:/g, "");
            changedValue = changedValue.replace(/\s/g, "");
            if(isNaN(changedValue) || 
              changedValue.indexOf(".")>-1 ||
              changedValue.length>14) {
              event.currentTarget.value = value ? value : "";
            }
            else {
              var mask = "__/__/____ __:__:__";
              var result = [];
              var replacedIndex = 0;
              for(var i=0; i<mask.length; i++) {
                if(mask[i]=="_" && replacedIndex<changedValue.length) {
                  result[i] = changedValue[replacedIndex];
                  replacedIndex++;
                }
                else if(replacedIndex<changedValue.length) {
                  result[i] = mask[i]
                }
              }
              event.currentTarget.value = result.join('');
            }  
            break;
          case Constants.selectKeys.metric.dataType.TIME:
            changedValue = changedValue.replace(/:/g, "");
            changedValue = changedValue.replace(/\s/g, "");
            if(isNaN(changedValue) || 
              changedValue.indexOf(".")>-1 ||
              changedValue.length>6) {
              event.currentTarget.value = value ? value : "";
            }
            else {
              var mask = "__:__:__";
              var result = [];
              var replacedIndex = 0;
              for(var i=0; i<mask.length; i++) {
                if(mask[i]=="_" && replacedIndex<changedValue.length) {
                  result[i] = changedValue[replacedIndex];
                  replacedIndex++;
                }
                else if(replacedIndex<changedValue.length) {
                  result[i] = mask[i]
                }
              }
              if(result.length > 0 && result.length < 3) {
                result.push(":");                
                event.currentTarget.value = result.join('');
                event.currentTarget.selectionStart = result.length-1;
                event.currentTarget.selectionEnd = result.length-1;
              }
              else {
                event.currentTarget.value = result.join('');                
              }
            }  
            break;
          default:
        }
      }
      else if(dataType && (dataType.toUpperCase() in Constants.formulaEditor.dataTypesTextBox)) {
        switch (dataType) {
          case Constants.formulaEditor.dataTypesTextBox.ID_CODE:
            if(!(/^[a-zA-Z0-9_]*$/.test(event.currentTarget.value))) {
              event.currentTarget.value = value ? value : "";
            }
            break;
          default:
        }
      }
      if(onChange) {
        onChange(event);
      }      
  };

  const handleResetSearchText = (event) => {
    event.currentTarget.value = "";
    event.currentTarget.id = id;
    if(onChange) {
      onChange(event);
    } 
  }
  
  const dataPath = props["data-path"];
  const dataIsOption = props["data-isoption"]; 
  const dataAction = props["data-action"];   
  let filtered_value = value ? value : "";
  if(dataType==Constants.selectKeys.metric.dataType.PERCENTAGE && filtered_value!="" && filtered_value.indexOf("%")==-1) {
    let numberFormater = new Intl.NumberFormat('en-US', {useGrouping:false, style: "percent", maximumFractionDigits:20});
    filtered_value = numberFormater.format(filtered_value);
  }
  return (
    <label className={"custom-input matter-textfield-" + styleType + (className ? " " + className : "") }>
      <input 
        id={id}
        ref={ref}
        data-path={dataPath}
        data-isoption={dataIsOption}
        data-action={dataAction}
        placeholder=" "
        maxLength={maxlength}
        type={type}                
        value={filtered_value}
        onChange={handleOnChange}
        disabled={disabled}
        autoComplete={autoComplete ? autoComplete : "off"}
        onKeyDown={(onKeyEnter || onKeyEsc) ? InterfaceTooling.getOnKeyEnterOrEscHandler(onKeyEnter,onKeyEsc) : null}
      />
      <span>{labelLocale}</span>
      {toolTipContent && (
        <HoverTooltip 
          toolTip={toolTipContent}
          toolTipType={Constants.interface.toolTip.formItemHelp}
          placement="right-end" 
          enterDelay={300} 
          leaveDelay={100}
          classes={{popper: "custom_input_tooltip object_editor_textbox_input_tooltip", tooltip: "custom_input_tooltip_inner object_editor_textbox_input_tooltip_inner"}}
        >
          <div className="textfield_input_tooltip_icon_wrapper">
            <i 
              className="fas fa-question-circle"
            />
            {/* <div className="arrow_wrapper"></div> */}
          </div>
        </HoverTooltip>
      )}
      {(showClearTextButton && filtered_value) && (
        <i 
          className="clear_text_button fas fa-times-circle"
          onClick={handleResetSearchText}
          data-path={dataPath}
          data-isoption={dataIsOption}
          data-action={dataAction}
        />
      )}
    </label>
  );
});

export default TextBox;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/textBox.jsx